import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { AuthorizationGuard } from './shared/guards/authorization.guard';

const APP_ROUTES: Routes = [
    {
        path: 'dashboard',
        component: HomeComponent,
        loadChildren: './dashboard/dashboard.module#DashboardModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'merchants',
        component: HomeComponent,
        loadChildren: './merchants/merchants.module#MerchantsModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'fundraisers',
        component: HomeComponent,
        loadChildren: './fundraisers/fundraisers.module#FundraisersModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'offers',
        component: HomeComponent,
        loadChildren: './offers/offers.module#OffersModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'login',
        redirectTo: '/',
        pathMatch: 'full'
    },
    {
        path: '',
        component: LoginComponent,
        data: { title: "Login" }
    },
    {
        path: 'home',
        component: HomeComponent,
        data: { title: "Home page" }
    },
    {
        path: 'products',
        component: HomeComponent,
        loadChildren: './products/products.module#ProductsModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'employees',
        component: HomeComponent,
        loadChildren: './employees/employees.module#EmployeesModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'members',
        component: HomeComponent,
        loadChildren: './members/members.module#MembersModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'orders',
        component: HomeComponent,
        loadChildren: './orders/orders.module#OrdersModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'offer-redemptions',
        component: HomeComponent,
        loadChildren: './offer-redemptions/redemptions.module#OfferRedemptionsModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'award-redemptions',
        component: HomeComponent,
        loadChildren: './award-redemptions/redemptions.module#AwardRedemptionsModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'notifications',
        component: HomeComponent,
        loadChildren: './notifications/notifications.module#NotificationsModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'promo',
        component: HomeComponent,
        loadChildren: './promo/promo.module#PromoModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'email-templates',
        component: HomeComponent,
        loadChildren: './email-templates/email-templates.module#EmailTemplatesModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'settings',
        component: HomeComponent,
        loadChildren: './settings/settings.module#SettingsModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'terminals',
        component: HomeComponent,
        loadChildren: './terminals/terminals.module#TerminalsModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'reporting-members',
        component: HomeComponent,
        loadChildren: './reporting-members/reporting-members.module#ReportingMembersModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'reporting-merchants',
        component: HomeComponent,
        loadChildren: './reporting-merchants/reporting-merchants.module#ReportingMerchantsModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'reporting-internal-orders',
        component: HomeComponent,
        loadChildren: './reporting-internal-orders/reporting-internal-orders.module#ReportingInternalOrdersModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: 'reporting-comparison',
        component: HomeComponent,
        loadChildren: './reporting-comparison/reporting-comparison.module#ReportingComparisonModule',
        canActivate: [AuthorizationGuard]
    },
    {
        path: "**",
        redirectTo: '/',
        pathMatch: 'full'
    }
];

export const routing = RouterModule.forRoot(APP_ROUTES);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts